import type { IPlainTooltipProps } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    ExcelExportButton,
    ExportVariantsDropdown,
} from "app/pages/sales-intelligence/common-components/table-actions-panel";

import type { WebsitesExportOptionsDropdownProps } from "./types";

const LeadsExportOptionsDropdown = (props: WebsitesExportOptionsDropdownProps) => {
    const { children, isDisabled = false, tooltipDisabledProps, isCloseByClick = true, onOpen } = props;

    function getTooltipProps(): IPlainTooltipProps {
        if (isDisabled && typeof tooltipDisabledProps !== "undefined") {
            return {
                enabled: true,
                ...tooltipDisabledProps,
            };
        }

        return { enabled: false };
    }

    return (
        <ExportVariantsDropdown
            button={
                <ExcelExportButton
                    isDisabled={isDisabled}
                    onClick={onOpen}
                >
                    {translate("si.multi_selector.initial_state.button.excel.label")}
                </ExcelExportButton>
            }
            buttonTooltipProps={getTooltipProps()}
            isCloseByClick={isCloseByClick}
        >
            {children}
        </ExportVariantsDropdown>
    );
};

export default LeadsExportOptionsDropdown;
